enum EvalFramework {
  LLM_BEHAVIOR_EVAL = 'llm-behavior-eval',
  INSPECT_EVALS = 'inspect-evals',
}

const evalFrameworkOptions: Array<{
  value: EvalFramework
  label: string
  description: string
}> = [
  {
    value: EvalFramework.LLM_BEHAVIOR_EVAL,
    label: 'Hirundo evals',
    description: 'Bias, hallucination, and prompt-injection tests',
  },
  {
    value: EvalFramework.INSPECT_EVALS,
    label: 'External evals',
    description: 'Run Inspect AI benchmarks',
  },
]

export { EvalFramework, evalFrameworkOptions }
